export type InputConfig =
  | {
      component: "TextInput";
      id: string;
      label: string;
      name: string;
      placeholder: string;
      required: boolean;
      type: string;
      mask?:
        | "cpf_cnpj"
        | "email"
        | "phone"
        | "cep"
        | "money";
    }
  | {
      component: "SelectField";
      id: string;
      label: string;
      name: string;
      placeholder: string;
      required: boolean;
      type: "select";
      options:
        | { label: string; value: string }[]
        | "ufs"
        | "cities";
    };

export const inputs: InputConfig[] = [
  {
    component: "SelectField",
    id: "plan",
    type: "select",
    label: "PLANO",
    name: "plano",
    placeholder: "Selecione o plano",
    required: true,
    options: [
      { label: "OURO", value: "OURO" },
      { label: "PRATA", value: "PRATA" },
      { label: "SELECT", value: "SELECT" },
    ],
  },
  {
    component: "TextInput",
    id: "proprietario",
    label: "PROPRIETÁRIO",
    name: "proprietario.nome",
    placeholder: "Digite o nome",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "cpf",
    label: "CPF",
    name: "proprietario.cpf_cnpj",
    placeholder: "Digite o cpf",
    required: true,
    type: "text",
    mask: "cpf_cnpj",
  },
  {
    component: "TextInput",
    id: "cnpj",
    label: "CNPJ",
    name: "empresa.cpf_cnpj",
    placeholder: "Digite o cnpj",
    required: true,
    type: "text",
    mask: "cpf_cnpj",
  },
  {
    component: "TextInput",
    id: "nome",
    label: "RAZÃO SOCIAL",
    name: "empresa.nome",
    placeholder: "Digite a razão social",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "nome_fantasia",
    label: "NOME FANTASIA (MARCA)",
    name: "empresa.nome_fantasia",
    placeholder: "Digite o nome fantasia",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "email",
    label: "EMAIL",
    name: "proprietario.email",
    placeholder: "Digite o email",
    required: true,
    type: "text",
    mask: "email",
  },
  {
    component: "TextInput",
    id: "telefone",
    label: "TELEFONE",
    name: "empresa.telefone",
    placeholder: "Digite o telefone",
    required: true,
    type: "text",
    mask: "phone",
  },
  {
    component: "TextInput",
    id: "capacidade",
    label: "CAPACIDADE",
    name: "capacidade",
    placeholder: "Digite a capacidade",
    required: true,
    type: "number",
  },
  {
    component: "TextInput",
    id: "usuario",
    label: "NOME DE USUÁRIO",
    name: "proprietario.username",
    placeholder: "Digite o usuario",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "password",
    label: "SENHA",
    name: "proprietario.password",
    placeholder: "Digite a senha",
    required: true,
    type: "password",
  },
  {
    component: "TextInput",
    id: "passwordConfirm",
    label: "CONFIRMAÇÃO DE SENHA",
    name: "proprietario.passwordConfirm",
    placeholder: "Confirme a senha",
    required: true,
    type: "password",
  },

  // Endereço
  {
    component: "TextInput",
    id: "cep",
    label: "CEP",
    name: "logradouro.cep",
    placeholder: "Digite o cep",
    required: true,
    type: "text",
    mask: "cep",
  },
  {
    component: "TextInput",
    id: "endereco",
    label: "LOGRADOURO",
    name: "logradouro.endereco",
    placeholder: "Digite o logradouro",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "numero",
    label: "NÚMERO",
    name: "logradouro.numero",
    placeholder: "Digite o número",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "bairro",
    label: "BAIRRO",
    name: "logradouro.bairro",
    placeholder: "Digite o bairro",
    required: true,
    type: "text",
  },
  {
    component: "SelectField",
    id: "uf",
    type: "select",
    label: "UF",
    name: "logradouro.uf",
    placeholder: "Selecione a uf",
    required: true,
    options: "ufs",
  },
  {
    component: "SelectField",
    id: "cidade",
    label: "CIDADE",
    type: "select",
   
    name: "logradouro.cidade",
    placeholder: "Digite a cidade",
    required: true,
    options: "cities",
  },

  // Dados de pagamento
  {
    component: "TextInput",
    id: "nome_proprietario",
    label: "NOME",
    name: "dadosPagamento.nome",
    placeholder: "Digite o nome",
    required: true,
    type: "text",
  },
  {
    component: "TextInput",
    id: "cpf_pagamento",
    label: "CPF",
    name: "dadosPagamento.cpf_cnpj",
    placeholder: "Digite o cpf",
    required: true,
    type: "text",
    mask: "cpf_cnpj",
  },
  {
    component: "TextInput",
    id: "email_pagamento",
    label: "EMAIL DE COBRANÇAS",
    name: "dadosPagamento.email",
    placeholder: "Digite o email",
    required: true,
    type: "text",
    mask: "email",
  },
  {
    component: "TextInput",
    id: "telefone_pagamento",
    label: "TELEFONE",
    name: "dadosPagamento.telefone",
    placeholder: "Digite o telefone",
    required: true,
    type: "text",
    mask: "phone",
  },
]

export const empresasinputs = inputs.filter((input) =>
  [
    "plan",
    "proprietario",
    "cpf",
    "cnpj",
    "nome",
    "nome_fantasia",
    "email",
    "telefone",
    "capacidade",
    "usuario",
    "password",
    "passwordConfirm",
  ].includes(input.id)
)

export const enderecoinputs = inputs.filter((input) =>
  [
    "cep",
    "endereco",
    "numero",
    "bairro",
    "uf",
    "cidade",
  ].includes(input.id)
)

export const pagamentoinputs = inputs.filter((input) =>
  [
    "nome_proprietario",
    "cpf_pagamento",
    "email_pagamento",
    "telefone_pagamento",
  ].includes(input.id)
)